import { ShadcnForm } from '@shadcn-features/core';
import type { ReactNode } from 'react';
import {
    ProcessFieldWithTableColumns,
    ServiceFieldTableValueDto,
    ServiceVM,
} from '@shared/types/process';
import { TableFieldInner } from './TableFieldInner';
import { parseTableFieldValue } from './tableFieldUtils';

type Props = {
    field: ProcessFieldWithTableColumns;
    service?: ServiceVM;
    disabled?: boolean;
    readOnly?: boolean;
    name?: string;
    label?: ReactNode;
    tooltip?: ReactNode;
    required?: boolean;
};

export function TableField({
    field,
    service,
    disabled,
    readOnly,
    name,
    label,
    tooltip,
    required,
}: Props) {
    if (!name) {
        return null;
    }

    return (
        <ShadcnForm.Item name={name} required={required} tooltip={tooltip}>
            {({ value, onChange }) => {
                const parsed = parseTableFieldValue(value);

                return (
                    <TableFieldInner
                        disabled={disabled}
                        field={field}
                        label={label}
                        readOnly={readOnly}
                        required={required}
                        service={service}
                        tooltip={tooltip}
                        value={parsed.rows}
                        onChange={(next: ServiceFieldTableValueDto) =>
                            onChange(next)
                        }
                    />
                );
            }}
        </ShadcnForm.Item>
    );
}
